import { render, staticRenderFns } from "./RoomMessageCard.vue?vue&type=template&id=2456d481&scoped=true"
import script from "./RoomMessageCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./RoomMessageCard.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./RoomMessageCard.vue?vue&type=style&index=0&id=2456d481&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2456d481",
  null
  
)

export default component.exports